const tasks = {
	title: "Tasks",
	new_task: "New Task",
	edit_task: "Edit Task: {name}",
	view_task: "View Task: {name}",
	list_title: "List of Tasks",
	list_subtitle: "Manage Task",
	create_title: "Create New Task",
	update_title: "Update Task",
	address_title: "Address",
	details_title: "Task Details",
	id: "ID",
	name: "Title",
	description: "Description",
	place: "Place",
	instructor_id: "Instructor",
	start_date: "Start Date",
	start_time: "Start Time",
	start_datetime: "Start Date/Time",
	end_date: "End Date",
	end_time: "End Time",
	end_datetime: "End Date/Time",
	status: "Status",
	created_by: "Created By",
};
export default tasks;